module.exports = __webpack_public_path__ + "UX41.png?24a12173d0de104e571c6c397831f1f5";


//////////////////
// WEBPACK FOOTER
// ./src/assets/UX41.png
// module id = 92
// module chunks = 0